import React, { Component } from 'react';
import {aDot} from '../Decorators/Checkmarks'
import { siteLastContact } from '../database/apiv2SiteAccessor';
import { sanitizeDateTime } from '../timeFunctions/timeFns';

import './SiteHealthFilter.css'

export default class SiteHealthFilter extends Component {
  constructor(props) {
    super(props);
    
    this.histogram = [0, 0, 0, 0, 0, 0]
    this.menuItem = this.menuItem.bind(this)
    this.prevCount = undefined
  }
  componentDidMount() {
    this.initHistogram()
    this.prevCount = this.props.siteMap().size
  }
  componentDidUpdate(){
    if (this.prevCount !== this.props.siteMap().size) {
      this.initHistogram()
      this.prevCount = this.props.siteMap().size
    }
  }
  menuItem(item, label){
    if (this.props.filter) this.props.filter(item, label)
  }
  initHistogram () {  // needs speed
    const cache = this.props.siteMap()
    if (cache && cache?.size) {
      let totals = [0, 0, 0, 0, 0, 0]
      const max = [1, 2, 14, 30, Number.MAX_VALUE]
      const now = new Date().getTime()
      for (const site of cache.values()) {
        const lc = sanitizeDateTime(siteLastContact(site), {zone: 'UTC'})
        const ago = Math.floor((now - lc.getTime()) /86400000)
        totals[1+max.findIndex(i=> ago < i )] +=1
      }
      totals[0] = cache.size
      const scale = 100 / cache.size
      this.histogram = totals.map (t => t*scale)
    }
  }
  render() {
    //console.log (this.props)
    return (
      <form>
        <label className="filter-radio" onClick={()=>this.menuItem([0, Number.MAX_VALUE], "All")}>
        <span className="solid-pie" style={{'--size':this.histogram[0]+'%'}} id="all" name="contact"
             /> All</label>
        <label className="filter-radio" onClick={()=>this.menuItem([0, 1], "0-1 Day")}>
          <span className="small-pie" style={{'--size':this.histogram[1]+'%'}} id="24" />
          &nbsp;{aDot("small-dot", "dotb wg-green")} 0-1 Day</label>
        <label className="filter-radio" onClick={()=>this.menuItem([1, 2], "1-2 Days")}> 
          <span className="small-pie" style={{'--size':this.histogram[2]+'%'}} id="24"/>
          &nbsp;{aDot("small-dot", "dotb wg-yellow")}1-2 Days</label>
        <label className="filter-radio" onClick={()=>this.menuItem([2,14], '2-14 Days')}>
          <span className="small-pie" style={{'--size':this.histogram[3]+'%'}} id="48"/>
          &nbsp;{aDot("small-dot", "dotb wg-red")}2-14 Days</label>
        <label className="filter-radio" onClick={()=>this.menuItem([14,30], "14-30 Day")}>
          <span className="small-pie" style={{'--size':this.histogram[4]+'%'}} id="336"/>
          &nbsp;{aDot("small-dot", "dotb wg-black")}14-30 Days</label>
        <label className="filter-radio" onClick={()=>this.menuItem([30,Number.MAX_VALUE], "Over 30 D")}>
          <span className="small-pie" style={{'--size':this.histogram[5]+'%'}} id="long" />
            &nbsp;{aDot("small-dot", "dotb wg-black")} Over 30 days</label>
      </form> 
    );
  }
}
